/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import React, { useContext, useEffect } from "react";

import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard PRO React icons
import SpaceShip from "examples/Icons/SpaceShip";
import Document from "examples/Icons/Document";
import Cube from "examples/Icons/Cube";
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import CustomerSupport from "examples/Icons/CustomerSupport";
import Settings from "examples/Icons/Settings";
import CreditCard from "examples/Icons/CreditCard";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import FactoryIcon from "@mui/icons-material/Factory";

import { AccountContext } from "context/account";

function Sidenav() {
  const account = useContext(AccountContext);

  const sidenavItems = [
    // { icon: <Office />, label: "company info", href: "company-info" },
    { icon: <Document />, label: "account info", href: "account-info" },
    // { icon: <Settings />, label: "platform settings", href: "platform-settings" },
  ];
  if (account.account_type == "ma") {
    sidenavItems.push({
      icon: <FactoryIcon sx={{ width: 16, height: 16 }} />,
      label: "Project Settings",
      href: "project-settings",
    });
  }

  if (account.account_type == "de") {
    sidenavItems.push({
      icon: <ContactMailIcon sx={{ width: 16, height: 16 }} />,
      label: "invite friends",
      href: "invite-designer",
    });
  }
  sidenavItems.push({
    icon: <Cube sx={{ width: 16, height: 16 }} />,
    label: "reset password",
    href: "reset-password",
  });
  sidenavItems.push({
    icon: <AccountBoxIcon sx={{ width: 16, height: 16 }} />,
    label: "delete account",
    href: "delete-account",
  });

  const renderSidenavItems = sidenavItems.map(({ icon, label, href }, key) => {
    const itemKey = `item-${key}`;

    return (
      <SuiBox key={itemKey} component="li" pt={key === 0 ? 0 : 1}>
        <SuiTypography
          component="a"
          href={`#${href}`}
          variant="button"
          fontWeight="regular"
          color="text"
          textTransform="capitalize"
          sx={({
            borders: { borderRadius },
            functions: { pxToRem },
            palette: { light },
            transitions,
          }) => ({
            display: "flex",
            alignItems: "center",
            borderRadius: borderRadius.md,
            padding: `${pxToRem(10)} ${pxToRem(16)}`,
            transition: transitions.create("background-color", {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.shorter,
            }),

            "&:hover": {
              backgroundColor: light.main,
            },
          })}
        >
          <SuiBox mr={1.5} lineHeight={1}>
            {icon}
          </SuiBox>
          {label}
        </SuiTypography>
      </SuiBox>
    );
  });

  return (
    <Card
      sx={{
        borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
        position: "sticky",
        top: "1%",
      }}
    >
      <SuiBox
        component="ul"
        display="flex"
        flexDirection="column"
        p={2}
        m={0}
        sx={{ listStyle: "none" }}
      >
        {renderSidenavItems}
      </SuiBox>
    </Card>
  );
}

export default Sidenav;
